import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';

export class TurbulenceLayer extends BaseProduct {
  public readonly id: ProductId = 'turbulence';
  private lastModel: string = '';

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    this.layerManager.removeBufferedRasterLayer(this.id);
    this.layerManager.removeLayer(this.id);
    this.lastModel = '';
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 1.0);
    const current = targetTimeMs !== undefined ? targetTimeMs : state.currentTimeStep;
    if (!current) return;

    const abm = (manifest as any)?.turbulence?.available_by_model || {};
    const exposed: string[] = manifest.exposed_models?.turbulence || ['dafs', 'gfs', 'ecmwf', 'hgefs', 'gdps', 'icon13'];
    const hasModelFrames = (mKey: string): boolean => {
      const dates = abm[mKey] || abm[mKey.toLowerCase()];
      return !!(dates && typeof dates === 'object' && Object.keys(dates).length > 0);
    };

    const rawModel = state.selectedModels[this.id] || state.selectedModels['aviation_turbulence'];
    let model = (rawModel && rawModel !== 'blend') ? rawModel : (exposed[0] || 'gfs');
    if (Object.keys(abm).length > 0 && !hasModelFrames(model)) {
      const fallback = exposed.find(hasModelFrames) || Object.keys(abm).find(hasModelFrames);
      if (fallback) {
        model = fallback;
      }
    }

    // Cleanly purge previous MapLibre raster source when switching models
    if (this.lastModel && this.lastModel !== model) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      this.layerManager.removeLayer(this.id);
    }
    this.lastModel = model;

    const ok = this.updateStandardInterpolatedRaster({
      layerId: this.id,
      product: this.id,
      model,
      targetTime: current,
      opacity,
      minzoom: 0,
      maxzoom: 5
    });
    if (!ok) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      this.layerManager.removeLayer(this.id);
    }
  }
}

export default TurbulenceLayer;
